import { useTypewriter } from '@/hooks/useTypewriter';
import { useTranslation } from 'react-i18next';

interface TypewriterTextProps {
  className?: string;
}

export const TypewriterText = ({ className = '' }: TypewriterTextProps) => {
  const { t } = useTranslation();
  const texts = t('hero.typewriter', { returnObjects: true }) as string[];
  
  const { currentText } = useTypewriter({
    texts,
    typeSpeed: 100,
    deleteSpeed: 50,
    pauseBeforeDelete: 3000,
    pauseBeforeType: 200,
  });

  return (
    <span className={className}>
      {currentText}
      <span className="inline-block w-[2px] h-[0.9em] ml-1 bg-gradient-to-b from-newsletter-primary to-newsletter-accent animate-cursor-blink-refined translate-y-[0.1em]" />
    </span>
  );
};